<div class="content">
  <form #userCreateForm="ngForm" [formGroup]="userForm">

    <header>
      <div>
      </div>

      <div class="buttons">

        <button matButton="outlined"
          data-qa="cancel-user-button"
          (click)="westnetzSidenavService.closeRightnav()">
          <mat-icon svgIcon="innogy_picto_close"></mat-icon>
          Schließen
        </button>

        <button matButton="filled"
          color="primary"
          [disabled]="!userCreateForm.form.valid"
          data-qa="create-user-button"
          (click)="saveUser()">
          <mat-icon>save</mat-icon>
          {{createNew ? 'Anlegen' : 'Speichern'}}
        </button>

        @if (!createNew) {
          <button matButton="filled"
            class="button-warn"
            data-qa="delete-user-button"
            (click)="deleteUser()">
            <mat-icon svgIcon="innogy_picto_bin_c-check"></mat-icon>
            Löschen
          </button>
        }

      </div>
    </header>

    <div class="detail-main">

      <fieldset>
        <legend>Schnittstellen Benutzer {{createNew ? 'anlegen' : 'editieren'}}</legend>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Benutzername</mat-label>
          <input matInput
            maxlength="100"
            data-qa="username"
            formControlName="username"
            id="username"
            name="username"
            required/>
          @if (f.username.hasError('required')) {
            <mat-error>
              Bitte tragen Sie den Benutzername ein
            </mat-error>
          }
        </mat-form-field>

        <mat-form-field redispatchProvideReadonly>
          <mat-label>Passwort</mat-label>
          <input matInput
            [type]="passwordHide ? 'password' : 'text'"
            autocomplete="new-password"
            data-qa="password"
            formControlName="password"
            id="password"
            name="password"
            >
          <button mat-icon-button matSuffix (click)="passwordHide = !passwordHide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="passwordHide">
            <mat-icon>{{passwordHide ? 'visibility_off' : 'visibility'}}</mat-icon>
          </button>

          @if (f.password.hasError('required')) {
            <mat-error>
              Bitte tragen Sie das Password des Benutzers ein
            </mat-error>
          }
        </mat-form-field>

        <div fxLayout="row" fxLayoutAlign="space-between">
          <mat-slide-toggle formControlName="enabled" color="primary">
            Aktiviert
          </mat-slide-toggle>

          <mat-slide-toggle formControlName="allowRead" color="primary">
            Leserechte
          </mat-slide-toggle>

          <mat-slide-toggle formControlName="allowWrite" color="primary">
            Schreibrechte
          </mat-slide-toggle>
        </div>
      </fieldset>
    </div>
  </form>
</div>
